import {Component} from "react";
import React from "react";
import SVG from "react-inlinesvg";
import closeicon from "../../assets/close.svg";
import './Functionality.css';
import $ from "jquery";
import {objectToFormData, post} from '../../utils/api';
import Loading from "../Shared/Loading";
import {connect} from "react-redux";
import {fetchSearchData} from "../../actions/searchActions";

class Vertical extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: this.props.record,
            functionality: this.props.functionality,
            name:  this.props.record.name,
            action: this.props.action,
            errors: false
        };
        this.handleTextChange = this.handleTextChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    closeModal(e) {
        if (e.keyCode === 27) {
            this.props.toggleModal(false)
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.closeModal);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.closeModal);
        $("html, body").animate({scrollTop: 0}, 300);
    }
    handleTextChange(e) {
        let value = e.target.value;
        let name = e.target.name;

        this.setState({
            [name]: value
        });
    }
    handleCreate(e) {
        e.preventDefault();
        this.props.setLoading(true);
        let data = objectToFormData({
            name: this.state.name
        });
        this.setState({
            errors: false,
            loading: true,
        });
        post('manage/verticals/', data).then((res) => {
            this.props.refreshVerticals();
            this.props.toggleModal(false);
        }).catch(err => {
            this.setState({
                loading: false,
                errors: err.response.data.error_stack
            });
            this.props.setLoading(false);
        })
        this.props.dispatch(fetchSearchData());
    }
    handleUpdate(e){
        e.preventDefault();
        this.props.setLoading(true);
        let data = objectToFormData( {
            id: this.state.record.id,
            name: this.state.name
        });
        this.setState({
            errors: false,
            loading: true,
        });
        post('manage/verticals/' + data.id, data).then((res) => {
            this.props.refreshVerticals();
            this.props.toggleModal(false);
        }).catch(err => {
            this.setState({
                loading: false,
                errors: err.response.data.error_stack
            });
            this.props.setLoading(false);
        });
        this.props.dispatch(fetchSearchData());
    }
    handleDelete(e){
        if (!window.confirm("Deleting this vertical will remove it from any brand using it. This cannot be undone. Are you sure?")) {
            return;
        }
        this.props.setLoading(true);
        this.setState({
            errors: false,
            loading: true,
        });
        post('manage/verticals/delete/' + this.state.record.id).then((res) => {
            this.props.refreshVerticals();
            this.props.toggleModal(false);
        }).catch(err => {
            this.setState({
                loading: false,
                errors: err.response.data.error_stack
            });
            this.props.setLoading(false);
        })
    }
    render(){
        return(
        <div className="modal-overlay">
                <section className="modal modal-function vertical-modal">
                    <div className="modal-content">
                        <div onClick={() => this.props.toggleModal(false)} className="closeBtn">
                            <SVG src={closeicon}/>
                        </div>
                        {this.state.errors &&
                        <ul className="error-list">
                            {this.state.errors.map((error, key) => (
                                <li key={key}>{error.msg}</li>
                            ))}
                        </ul>
                        }
                        {this.props.action === 'update' &&
                            <div className="modal-header">
                                <h1>Edit Vertical</h1>
                            </div>
                        }
                        {this.props.action === 'create' &&
                            <div className="modal-header">
                                <h1>Create Vertical</h1>
                            </div>
                        }
                        <div className="form-group">
                            <label>Vertical Name</label>
                            <input className="form-control" name="name" autoComplete="off"
                                   defaultValue={this.state.name} onChange={this.handleTextChange}/>
                        </div>
                        {this.state.action === 'create' &&
                        <div className="button-wrapper">
                            <button className="button button--transparent" type="button"
                                    onClick={() => this.props.toggleModal(false)}>
                                Cancel
                            </button>
                            <button className="button button--blue" onClick={this.handleCreate}>
                                Create
                            </button>
                        </div>
                        }
                        {this.state.action === 'update' &&
                        <div className="button-wrapper">
                            <button className="button button--transparent" type="button"
                                    onClick={() => this.props.toggleModal(false)}>
                                Cancel
                            </button>
                            <button className="button button--red" type="button" onClick={this.handleDelete}>
                                Delete
                            </button>
                            <button className="button button--blue" onClick={this.handleUpdate}>
                                Update
                            </button>
                        </div>
                        }
                        {this.state.loading && <div className="loading-mask">
                            <Loading/>
                        </div>}
                    </div>
                </section>
        </div>
        )
    }
}
export default connect(null)(Vertical);
